export const signatureRecordStatusConfig = {
  signed: {
    value: 'signed',
    label: 'member.signatureRecord.status.signed',
    tagType: 'action',
  },
  expired: {
    value: 'expired',
    label: 'member.signatureRecord.status.expired',
    tagType: 'danger',
  },
  unsigned: {
    value: 'unsigned',
    label: 'member.signatureRecord.status.unsigned',
    tagType: 'info',
  },
}

export const signatureRecordStatusOptions = Object.values(signatureRecordStatusConfig)

export const signatureSourceTypeConfig = {
  appointmentOrder: {
    value: 'appointmentOrder',
    label: 'member.signatureRecord.sourceType.appointmentOrder',
    featureKey: 'admin.appointmentReservation.page',
  },
  memberStoreOrder: {
    value: 'memberStoreOrder',
    label: 'member.signatureRecord.sourceType.memberStoreOrder',
    featureKey: 'planModule.memberStore.page',
  },
  memberStoreOrderPointExchange: {
    value: 'memberStoreOrderPointExchange',
    label: 'member.signatureRecord.sourceType.memberStoreOrderPointExchange',
    featureKey: 'adminView.memberStorePointExchangeOrder.page',
  },
  memberExternalTransaction: {
    value: 'memberExternalTransaction',
    label: 'member.signatureRecord.sourceType.memberExternalTransaction',
    featureKey: 'admin.memberExternalTransaction.page',
  },
  manual: {
    value: 'manual',
    label: 'member.signatureRecord.sourceType.manual',
    featureKey: 'admin.signatureTemplate.manual.page',
  },
}

export const signatureSourceTypeOptions = Object.values(signatureSourceTypeConfig)

/**
 * 系統保留欄位 Key（簽名處、簽署日期），不可由使用者自行建立
 */
export const SYSTEM_FIELD_KEYS = ['簽名處', '簽署日期']

/**
 * 欄位種類設定（對齊 API 規格）
 */
export const signatureFieldTypeConfig = [
  { value: 'text', label: '簡答' },
  { value: 'richtext', label: '詳答' },
  { value: 'date', label: '日期' },
  { value: 'checkbox', label: '勾選方塊' },
  { value: 'signature', label: '簽名', hidden: true },
  { value: 'signDate', label: '簽署時間', hidden: true },
]

/**
 * 欄位屬性選項
 */
export const signatureAttributeOptions = [
  { value: 'autoFill', label: '會員註冊資料自動帶入' },
  { value: 'manual', label: '手動輸入' },
  { value: 'signature', label: '帶入會員簽名', hidden: true },
  { value: 'signDate', label: '系統日期自動帶入', hidden: true },
]

/**
 * 根據當前值動態生成欄位種類選項
 * 如果當前值是隱藏的選項，會將其加入並設為 disabled，以便正確顯示標籤
 * @param {Array} config - 欄位種類設定陣列
 * @param {string} currentValue - 當前欄位類型的值
 * @returns {Array} 選項陣列
 */
export const getOptions = (config, currentValue) => {
  const visibleOptions = [...config.filter(item => !item.hidden)]

  // 如果當前值是隱藏的選項，找到它並加入列表（設為 disabled）
  const currentOption = config.find(opt => opt.value === currentValue && opt.hidden)
  if (currentOption) {
    visibleOptions.push({
      ...currentOption,
      disabled: true,
    })
  }

  return visibleOptions
}
